import { render, staticRenderFns } from "./IframeViewer.vue?vue&type=template&id=1e163350&scoped=true"
import script from "./IframeViewer.vue?vue&type=script&lang=js"
export * from "./IframeViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e163350",
  null
  
)

export default component.exports